<template>
  <div class="km__modules__cockpitcall">
    <button class="km__button--icon cockpit opencockpit" type="button" name="cockpit"
            @click="openCockpit"
    >
      {{ $t("km_cockpit") }}
    </button>
  </div>
</template>

<script lang="ts" setup>
import {useStore} from "vuex";
import {OverlayNames} from "@km/store/frontendstate/TabOpenStatusStore";
import globalsObject from "@k/js/globalsObject";


const store = useStore();

const openCockpit = () => {
  globalsObject.googleTracker.trackPageview("cokpitclick.htm")
  store.commit("SET_OVERLAY_OPEN", OverlayNames.cockpit)
};

</script>

<style lang="scss" scoped>
.km__modules__cockpitcall {
  position: absolute;
  bottom: 200px;
  right: 20px;
  z-index: 1;
}

.km__button--icon {
  &.cockpit {
    &.opencockpit {
      background-image: url("data:image/svg+xml;base64,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");
    }
  }
}

</style>
